export const ROUTES = {
  HOME: 'home',
  FAQ: 'faq',
  PRIVACY_POLICY: 'privacy',
  CATCH_ALL: 'catch-all',
}
